import Cookies from "js-cookie";

const isBrowser = typeof document !== "undefined";

function setCookie(name, value, { expires } = {}) {
  if (!isBrowser) return;

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (expires) {
    let expiresDate = expires;
    if (typeof expires === "number") {
      expiresDate = new Date();
      expiresDate.setTime(expiresDate.getTime() + expires);
    }
    if (expiresDate instanceof Date && !Number.isNaN(expiresDate.getTime())) {
      cookie += `; expires=${expiresDate.toUTCString()}`;
    }
  }

  cookie += "; path=/";
  document.cookie = cookie;
}

export function saveAuthTokens({ token, expires, refreshToken, refreshTokenExpires } = {}) {
  if (!token) return;

  let expiresDate = null;

  if (expires) {
    const parsed = new Date(expires);
    if (!Number.isNaN(parsed.getTime())) {
      expiresDate = parsed;
    }
  }

  if (!expiresDate) {
    expiresDate = new Date();
    expiresDate.setTime(
      expiresDate.getTime() + 30 * 24 * 60 * 60 * 1000 //30 days default
    );
  }

  setCookie("token", token, { expires: expiresDate });

  if (refreshToken) {
    let refreshExpiresDate = expiresDate;

    if (refreshTokenExpires) {
      const parsedRefresh = new Date(refreshTokenExpires);
      if (!Number.isNaN(parsedRefresh.getTime())) {
        refreshExpiresDate = parsedRefresh;
      }
    }

    setCookie("refreshToken", refreshToken, { expires: refreshExpiresDate });
  }
}

export function clearAuthTokens() {
  if (!isBrowser) return;
  setCookie("token", "", { expires: new Date(0) });
  setCookie("refreshToken", "", { expires: new Date(0) });
}

export function getAuthToken() {
  return Cookies.get("token");
}

export function getRefreshToken() {
  return Cookies.get("refreshToken");
}
